(function (ws) {
    'use strict';
    ws.models.quoteConversionOrderModel = Backbone.Model.extend();
})(westcon);
